import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { AuthenticationService } from 'app/helpers/authentication.service';
import { Termo } from './models/Termo.model';
import { SituacaoTermo } from './models/SituacaoTermo.model';

@Injectable({ providedIn: 'root' })
export class DocumentosService {

  // CACHE POR TOKEN: UM NOVO LOGIN SEMPRE BUSCA DE NOVO
  private _situacao: SituacaoTermo | null = null;
  private _tokenSituacao: string | null = null;

  constructor(
    private http: HttpClient,
    private _authService: AuthenticationService,
  ) { }

  getTermos(): Observable<Termo> {
    return this.http.get<Termo>(`${environment.apiBackStage}/termos`);
  }

  getSituacao(forcar = false): Observable<SituacaoTermo> {
    const token = this._authService.currentUserValue?.accessToken ?? null;

    if (!forcar && this._situacao && this._tokenSituacao === token) {
      return of(this._situacao);
    }

    return this.http
      .get<SituacaoTermo>(`${environment.apiBackStage}/termos/situacao`)
      .pipe(
        tap((situacao) => {
          this._situacao = situacao;
          this._tokenSituacao = token;
        }),
      );
  }

  limparSituacao(): void {
    this._situacao = null;
    this._tokenSituacao = null;
  }
}
